<template>
  <div id="review-list">
    <div class="container-index">
      <a href="#" @click.prevent="goBackOrRedirect" class="no-deco mb-5">&lt; Retour</a>
      <div class="index-text">
        <h1 class="merriweather-reg-40 mb-2">{{ this.lodging.name }}</h1>
        <h4 class="merriweather-reg-40 mt-2">{{this.lodging.lodging_description.rating_value}}/5</h4>
      </div>
      <div v-if="this.lodging && this.lodging.ratings">
        <template v-for="resa in paginatedReviews">
          <div>
            <div v-if="resa.authorized" class="card-review">
              <div class="review-autor">
                <h3 class="raleway-reg-p13 mb-4"> Avis de {{resa.user_name}} :</h3>
                <p class="raleway-bold">{{ resa.global }}/5</p>
              </div>
              <p style="font-weight: bold" v-if="resa.source == 'tripadvisor'" class="merriweather-italic-13" >{{resa.title}}</p>
              <p class="merriweather-italic-13">{{resa.review}}</p>
              <div class="date-post">
                  <p class="raleway-reg-p13" v-if="resa.rated_at">Posté le {{ formatDate(resa.rated_at)}}</p>
                  <p class="raleway-reg-p13" v-else>Posté le {{ formatDate(resa.created_at)}}</p>
              </div>
            </div>
          </div>
        </template>
        
        <!-- Pagination Controls -->
        <nav v-if="totalPages > 1" class="mt-5">
          <ul class="pagination">
            <li class="page-item" @click="scrollToTop">
              <button
                v-for="pageNumber in visiblePages"
                :key="pageNumber"
                :class="currentPage === pageNumber ? 'active-item' : ''"
                type="button"
                class="page-link"
                @click="goToPage(pageNumber)"
              >
                {{ pageNumber }}
              </button>
            </li>
          </ul>
        </nav>
      </div>
      <div v-else>
        <p class="raleway-reg-p15 text-center mt-5">Cet établissement n'a pas encore d'avis.</p>
      </div>
    </div>
  </div>
</template>
<script>

  import fetcher from 'packs/shared/api.js';

  export default{
    name: 'review-list',
    props: [ 'lodging'],
    data() {
      return{
        resaMount: null,
        currentPage: 1,
        itemsPerPage: 20,
      }
    },
    computed: {
      authorizedReviews() {
        if (!this.lodging || !this.lodging.ratings) return [];
        return this.lodging.ratings
          .filter(resa => resa.authorized)
          .map((resa) => {
            const nextResa = { ...resa };

            if (typeof nextResa.review === "string" && this.isLikelyMojibake(nextResa.review)) {
              const fixedReview = this.fixMojibake(nextResa.review);
              if (fixedReview) {
                nextResa.review = fixedReview;
              }
            }

            if (typeof nextResa.title === "string" && this.isLikelyMojibake(nextResa.title)) {
              const fixedTitle = this.fixMojibake(nextResa.title);
              if (fixedTitle) {
                nextResa.title = fixedTitle;
              }
            }

            if (typeof nextResa.user_name === "string" && this.isLikelyMojibake(nextResa.user_name)) {
              const fixedUserName = this.fixMojibake(nextResa.user_name);
              if (fixedUserName) {
                nextResa.user_name = fixedUserName;
              }
            }

            return nextResa;
          })
          .sort((a, b) => new Date(b.rated_at) - new Date(a.rated_at));
      },
      totalAuthorizedReviews() {
        return this.authorizedReviews.length;
      },
      totalPages() {
        return Math.ceil(this.totalAuthorizedReviews / this.itemsPerPage);
      },
      paginatedReviews() {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.authorizedReviews.slice(start, end);
      },
      visiblePages() {
        const pages = [];
        for (let i = 1; i <= this.totalPages; i++) {
          pages.push(i);
        }
        return pages;
      }
    },
    methods: {
      async fetchResa() {
        try {
          const response = await fetcher.get('/reservation-hotel/'+this.lodging.id);
          this.resaMount = response.data;
          console.log('this.resaMount');
          console.log(this.resaMount);
        } catch(e) {
          console.error(e);
        }
      },
       formatDate(date){
        const set = new Date(date)
        const options = {weekday: "long", year: "numeric", month: "long", day: "numeric"};
        return set.toLocaleString('default', options)
      },
      goBackOrRedirect() {
        const currentUrl = window.location.href;
        const previousUrl = document.referrer;

        if (previousUrl && previousUrl !== currentUrl && window.history.length > 1) {
          window.history.back();
        } else {
          window.location.href = '/reservation-hotel/' + this.lodging.slug;
        }
      },
      goToPage(page) {
        if (page >= 1 && page <= this.totalPages) {
          this.currentPage = page;
        }
      },
      scrollToTop() {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      },
      isLikelyMojibake(str) {
        if (typeof str !== "string" || !str.length) return false;
        // Also catch the Ã + NBSP pattern (à, é, etc. corrupted)
        return /Ã[\u00A0\s]|Ã©|Ã¨|Ã |Ã®|Ã´|Ã»|Ã§|Ã«|Ã¢|Ã¹|Ã¯|Ã¦|Ã¼|Ã½|Â |â€|â€™|â€œ|â€"|â€"/.test(str);
      },
      fixMojibake(str) {
        if (typeof str !== "string" || !str.length) return str;

        try {
          // Step 1: Replace HTML entities that crept in
          let fixed = str
            .replace(/&nbsp;/g, '\u00A0')   // named entity → actual NBSP
            .replace(/&#160;/g, '\u00A0');  // numeric entity → actual NBSP

          // Step 2: Re-encode each char as its Latin-1 byte value, then decode as UTF-8
          const bytes = Uint8Array.from(
            Array.from(fixed, char => char.charCodeAt(0) & 0xFF)
          );

          const decoded = new TextDecoder("utf-8").decode(bytes);

          // Step 3: Clean up any leftover NBSP → regular space
          return decoded.replace(/\u00A0/g, ' ');
        } catch (e) {
          return str;
        }
      }
    },
  }
</script>

<style scoped>
.page-item {
  border-color: black;
  button {
    display: inline-block;
    color: black;
  }
}

.active-item {
  color: green;
  border-color: black;
  border-style: solid;
}
</style>
